export const commaStringToNumber = (string: string) => {
  // TODO: Check whether string will have commas as a separator for every three digits. In the future it will be determined by region and separator may not be comma.
  const noComma = string.replace(/,/g, '')
  return Number(noComma)
}
